import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {map, tap} from 'rxjs/operators';
import { ImageActionDto } from '../../../../../api/src/asset/models/image-action.dto';
import { AssetDto } from "../../../../../api/src/asset/models/asset.dto";
import { DefaultResponse } from "../../_core/state/session";
import { environment } from "../../../environments/environment";
import { DataSourceGenerateDto } from "../../../../../api/src/data-source/dtos/data-source-generate.dto";

@Injectable({ providedIn: 'root' })
export class ImageEditorService {

	constructor(
		private http: HttpClient
	) {}

	public generate(dataSourceId: string, params: DataSourceGenerateDto) {
		return this.http.post<DefaultResponse<Partial<AssetDto>[]>>(`${environment.apiUrl}/data-source/${dataSourceId}/generate`, params).pipe(
			map(response => response?.data)
		);
	}

	public executeAction(action: ImageActionDto<any>) {
		return this.http.post<DefaultResponse<any>>(`${environment.apiUrl}/asset/image/action`, action).pipe(
			map(response => response?.data)
		);
	}

	/**
	 * Get available AI models for a specific capability
	 * @param capability - The capability type (e.g., 'text-to-image', 'chat', 'audio')
	 * @param projectId - Optional project ID for context-based filtering
	 */
	public getAvailableModels(capability: string, projectId?: number) {
		const params: any = { capability };
		if (projectId) {
			params.projectId = projectId;
		}
		return this.http.get<any>(`${environment.apiUrl}/ai/get-models`, { params }).pipe(
			map(response => response)
		);
	}

	/**
	 * Generate images using text-to-image AI endpoint (fallback mode)
	 * @param request - Text-to-image generation parameters
	 */
	public generateTextToImage(request: any) {
		return this.http.post<any>(`${environment.apiUrl}/ai/text-to-image`, request).pipe(
			map(response => response)
		);
	}

	/**
	 * Edit an image using natural language AI
	 * @param request - Image edit request parameters
	 */
	public editImageWithText(request: any) {
		return this.http.post<any>(`${environment.apiUrl}/ai/edit-image-with-text`, request).pipe(
			map(response => response)
		);
	}
}
